import { getUserWizardsStatus } from '@services/external/user.api';
import { useQuery, UseQueryOptions } from 'react-query';
import { IUserWizardStatuses } from 'types/users';

const INITIAL_DATA: IUserWizardStatuses = {
  lifeIdWizard: false,
  loginWizard: false,
  managementWizard: false,
  roleWizard: false,
  providerWizard: false,
};

async function handler() {
  const { data } = await getUserWizardsStatus();

  return data.data;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function useUserWizards(options?: UseQueryOptions<TQueryData, unknown, TQueryData, any[]>) {
  return useQuery(['user:wizards'], handler, {
    ...options,
  });
}

export default useUserWizards;
